export const SourceFilter = {
  ALL: 'all',
  PLANNED: 'planned',
  UNPLANNED: 'unplanned',

  labels: {
    all: 'Все',
    planned: 'По договору',
    unplanned: 'Внеплановый',
  },
  colors: {
    all: 'grey',
    planned: 'blue',
    unplanned: 'purple',
  },
  title: 'Основание разработки',
  description: 'Уточните, входит ли РИД в утвержденный план работ по договору',

  matches(source, filterValue) {
    if (filterValue === this.ALL) return true
    return source === filterValue
  },
}

export const StatusFilter = {
  ALL: 'all',
  REGISTERED: 'registered',
  APPLIED: 'applied',
  PENDING: 'pending',
  UNKNOWN: 'unknown',

  labels: {
    all: 'Все',
    registered: 'Зарегистрирован',
    applied: 'Подана заявка',
    pending: 'На проверке',
    unknown: 'К исполнению',
  },
  icons: {
    all: '',
    registered: 'mdi-file-certificate-outline',
    applied: 'mdi-text-box-check-outline',
    pending: 'mdi-progress-clock',
    unknown: 'mdi-shovel',
  },
  colors: {
    all: 'grey',
    registered: 'green',
    applied: 'deep-orange',
    pending: 'blue-grey',
    unknown: 'pink',
  },
  title: 'Статус РИД',
  description: 'Выберите стадию, на которой находится РИД',

  matches(status, filterValue) {
    if (filterValue === this.ALL) return true
    return status === filterValue
  },
}
